export const initialTrainsData = [
  {
    id: 1,
    number: "43К",
    title: "EuroNight",
    type: "Night",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train1.webp",
    description: "Найшвидший рейс до Польщі.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-01T22:00:00" },
      to:   { city: "Warsaw", station: "Warszawa Centralna", arrivalTime: "2026-06-02T08:30:00" },
      duration: "10г 30хв",
    },
    seat: { carriage: 2, number: 14, class: "Coupe" },
    payment: { basePrice: 100, status: "Paid" },
  },
  {
    id: 2,
    number: "12",
    title: "Карпатський експрес",
    type: "Night",
    hasWifi: false,
    hasAirConditioning: false,
    imageUrl: "/train/train2.webp",
    description: "Комфортний нічний переїзд.",
    route: {
      from: { city: "Lviv", station: "Lviv-Holovnyi", departureTime: "2026-06-02T20:15:00" },
      to:   { city: "Prague", station: "Praha Hlavní nádraží", arrivalTime: "2026-06-03T10:45:00" },
      duration: "14г 30хв",
    },
    seat: { carriage: 4, number: 8, class: "Lux" },
    payment: { basePrice: 150, status: "Paid" },
  },
  {
    id: 3,
    number: "105",
    title: "Чорноморець",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train3.png",
    description: 'Фірмовий поїзд "Чорноморець".',
    route: {
      from: { city: "Odesa", station: "Odesa-Holovna", departureTime: "2026-06-03T07:00:00" },
      to:   { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", arrivalTime: "2026-06-03T13:30:00" },
      duration: "6г 30хв",
    },
    seat: { carriage: 3, number: 22, class: "1-Class" },
    payment: { basePrice: 80, status: "Paid" },
  },
  {
    id: 4,
    number: "7",
    title: "Міжнародний експрес",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train4.jfif",
    description: "Міжнародний експрес.",
    route: {
      from: { city: "Ivano-Frankivsk", station: "Ivano-Frankivsk", departureTime: "2026-06-04T05:45:00" },
      to:   { city: "Berlin", station: "Berlin Hauptbahnhof", arrivalTime: "2026-06-04T22:00:00" },
      duration: "16г 15хв",
    },
    seat: { carriage: 1, number: 5, class: "1-Class" },
    payment: { basePrice: 120, status: "Paid" },
  },
  {
    id: 5,
    number: "15",
    title: "Слобожанський",
    type: "Night",
    hasWifi: false,
    hasAirConditioning: false,
    imageUrl: "/train/train5.jfif",
    description: "Прямий рейс через всю країну.",
    route: {
      from: { city: "Kharkiv", station: "Kharkiv-Pasazhyrskyi", departureTime: "2026-06-05T19:30:00" },
      to:   { city: "Lviv", station: "Lviv-Holovnyi", arrivalTime: "2026-06-06T07:15:00" },
      duration: "11г 45хв",
    },
    seat: { carriage: 6, number: 33, class: "2-Class" },
    payment: { basePrice: 90, status: "Paid" },
  },
  {
    id: 6,
    number: "749К",
    title: "Відень-Експрес",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train6.jpg",
    description: "Європейський комфорт.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-06T08:00:00" },
      to:   { city: "Vienna", station: "Wien Hauptbahnhof", arrivalTime: "2026-06-07T06:30:00" },
      duration: "22г 30хв",
    },
    seat: { carriage: 1, number: 3, class: "Lux" },
    payment: { basePrice: 200, status: "Paid" },
  },
  {
    id: 7,
    number: "741К",
    title: "Інтерсіті+",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train7.jpg",
    description: "Інтерсіті+ з кавою та Wi-Fi.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-07T06:30:00" },
      to:   { city: "Lviv", station: "Lviv-Holovnyi", arrivalTime: "2026-06-07T12:15:00" },
      duration: "5г 45хв",
    },
    seat: { carriage: 5, number: 24, class: "1-Class" },
    payment: { basePrice: 60, status: "Paid" },
  },
  {
    id: 8,
    number: "733",
    title: "Дніпро-Експрес",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train8.webp",
    description: "Денний швидкісний поїзд.",
    route: {
      from: { city: "Dnipro", station: "Dnipro-Holovnyi", departureTime: "2026-06-08T09:00:00" },
      to:   { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", arrivalTime: "2026-06-08T14:30:00" },
      duration: "5г 30хв",
    },
    seat: { carriage: 3, number: 11, class: "1-Class" },
    payment: { basePrice: 110, status: "Paid" },
  },
  {
    id: 9,
    number: "33",
    title: "Будапешт-Нічний",
    type: "Night",
    hasWifi: false,
    hasAirConditioning: true,
    imageUrl: "/train/train9.jpg",
    description: "Затишний маршрут до Угорщини.",
    route: {
      from: { city: "Lviv", station: "Lviv-Holovnyi", departureTime: "2026-06-09T21:00:00" },
      to:   { city: "Budapest", station: "Budapest-Keleti", arrivalTime: "2026-06-10T09:00:00" },
      duration: "12г 00хв",
    },
    seat: { carriage: 2, number: 18, class: "Coupe" },
    payment: { basePrice: 180, status: "Paid" },
  },
  {
    id: 10,
    number: "89",
    title: "Мюнхен Бізнес",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train10.avif",
    description: "Тривала подорож бізнес-класом.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-10T07:00:00" },
      to:   { city: "Munich", station: "München Hauptbahnhof", arrivalTime: "2026-06-11T07:30:00" },
      duration: "24г 30хв",
    },
    seat: { carriage: 1, number: 2, class: "Lux" },
    payment: { basePrice: 220, status: "Paid" },
  },
  {
    id: 11,
    number: "124",
    title: "Регіональний",
    type: "Night",
    hasWifi: false,
    hasAirConditioning: false,
    imageUrl: "/train/train1.webp",
    description: "Економічний регіональний рейс.",
    route: {
      from: { city: "Odesa", station: "Odesa-Holovna", departureTime: "2026-06-11T18:00:00" },
      to:   { city: "Vinnytsia", station: "Vinnytsia", arrivalTime: "2026-06-12T00:30:00" },
      duration: "6г 30хв",
    },
    seat: { carriage: 7, number: 42, class: "2-Class" },
    payment: { basePrice: 45, status: "Paid" },
  },
  {
    id: 12,
    number: "29",
    title: "Карпатський нічний",
    type: "Night",
    hasWifi: true,
    hasAirConditioning: false,
    imageUrl: "/train/train2.webp",
    description: "Нічний експрес через Карпати.",
    route: {
      from: { city: "Uzhhorod", station: "Uzhhorod", departureTime: "2026-06-12T20:30:00" },
      to:   { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", arrivalTime: "2026-06-13T08:45:00" },
      duration: "12г 15хв",
    },
    seat: { carriage: 4, number: 16, class: "Coupe" },
    payment: { basePrice: 130, status: "Paid" },
  },
  {
    id: 13,
    number: "722",
    title: "Полтавський ранковий",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train8.webp",
    description: "Швидкий ранковий поїзд.",
    route: {
      from: { city: "Poltava", station: "Poltava-Kyivska", departureTime: "2026-06-13T06:00:00" },
      to:   { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", arrivalTime: "2026-06-13T09:30:00" },
      duration: "3г 30хв",
    },
    seat: { carriage: 2, number: 9, class: "1-Class" },
    payment: { basePrice: 75, status: "Paid" },
  },
  {
    id: 14,
    number: "23",
    title: "Хелм-Директ",
    type: "Night",
    hasWifi: false,
    hasAirConditioning: true,
    imageUrl: "/train/train3.png",
    description: "Зручна стиковка з польськими поїздами.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-14T17:00:00" },
      to:   { city: "Chelm", station: "Chełm", arrivalTime: "2026-06-15T05:30:00" },
      duration: "12г 30хв",
    },
    seat: { carriage: 5, number: 28, class: "2-Class" },
    payment: { basePrice: 140, status: "Paid" },
  },
  {
    id: 15,
    number: "26",
    title: "Захід–Південь",
    type: "Night",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train4.jfif",
    description: "Поїзд єднання: Захід - Південь.",
    route: {
      from: { city: "Lviv", station: "Lviv-Holovnyi", departureTime: "2026-06-15T14:00:00" },
      to:   { city: "Odesa", station: "Odesa-Holovna", arrivalTime: "2026-06-16T04:00:00" },
      duration: "14г 00хв",
    },
    seat: { carriage: 3, number: 17, class: "Coupe" },
    payment: { basePrice: 95, status: "Paid" },
  },
  {
    id: 16,
    number: "702",
    title: "Чернігівський приміський",
    type: "High-Speed",
    hasWifi: false,
    hasAirConditioning: false,
    imageUrl: "/train/train5.jfif",
    description: "Приміський швидкісний маршрут.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-16T08:00:00" },
      to:   { city: "Chernihiv", station: "Chernihiv", arrivalTime: "2026-06-16T10:30:00" },
      duration: "2г 30хв",
    },
    seat: { carriage: 1, number: 44, class: "2-Class" },
    payment: { basePrice: 55, status: "Paid" },
  },
  {
    id: 17,
    number: "36",
    title: "Буковина-Перемишль",
    type: "Night",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train6.jpg",
    description: "Міжнародний рейс із Буковини.",
    route: {
      from: { city: "Chernivtsi", station: "Chernivtsi", departureTime: "2026-06-17T19:00:00" },
      to:   { city: "Przemysl", station: "Przemyśl Główny", arrivalTime: "2026-06-18T05:30:00" },
      duration: "10г 30хв",
    },
    seat: { carriage: 2, number: 7, class: "Coupe" },
    payment: { basePrice: 170, status: "Paid" },
  },
  {
    id: 18,
    number: "31",
    title: "Чотири столиці",
    type: "Night",
    hasWifi: false,
    hasAirConditioning: true,
    imageUrl: "/train/train7.jpg",
    description: "Поїзд чотирьох столиць.",
    route: {
      from: { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", departureTime: "2026-06-18T15:00:00" },
      to:   { city: "Riga", station: "Rīgas Centrālā stacija", arrivalTime: "2026-06-19T21:00:00" },
      duration: "30г 00хв",
    },
    seat: { carriage: 3, number: 12, class: "Lux" },
    payment: { basePrice: 125, status: "Paid" },
  },
  {
    id: 19,
    number: "402",
    title: "Венеційський туристичний",
    type: "Night",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train9.jpg",
    description: "Туристичний рейс до Італії.",
    route: {
      from: { city: "Lviv", station: "Lviv-Holovnyi", departureTime: "2026-06-19T16:00:00" },
      to:   { city: "Venice", station: "Venezia Santa Lucia", arrivalTime: "2026-06-21T10:00:00" },
      duration: "42г 00хв",
    },
    seat: { carriage: 1, number: 6, class: "Lux" },
    payment: { basePrice: 210, status: "Paid" },
  },
  {
    id: 20,
    number: "716",
    title: "Тернопільський двоповерховий",
    type: "High-Speed",
    hasWifi: true,
    hasAirConditioning: true,
    imageUrl: "/train/train10.avif",
    description: "Швидкий двоповерховий поїзд.",
    route: {
      from: { city: "Ternopil", station: "Ternopil", departureTime: "2026-06-20T07:15:00" },
      to:   { city: "Kyiv", station: "Kyiv-Pasazhyrskyi", arrivalTime: "2026-06-20T12:00:00" },
      duration: "4г 45хв",
    },
    seat: { carriage: 2, number: 31, class: "1-Class" },
    payment: { basePrice: 85, status: "Paid" },
  },
];

export const getAllCities = (trains) => {
  const cities = new Set();
  trains.forEach(train => {
    cities.add(train.route.from.city);
    cities.add(train.route.to.city);
  });
  return Array.from(cities).sort();
};